import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Provider Expression that allows azc-chip-option-list to register as a ControlValueAccessor.
 * This allows it to support [(ngModel)].
 * @docs-private
 */
export const AZC_AUTOCOMPLETE_SELECT_CONTROL_VALUE_ACCESSOR: any = {
	provide: NG_VALUE_ACCESSOR,
	// tslint:disable-next-line
	useExisting: forwardRef(() => AutocompleteSelectComponent),
	multi: true
};
@Component({
	selector: 'azc-autocomplete-select',
	templateUrl: './autocomplete-select.component.html',
	styleUrls: ['./autocomplete-select.component.scss'],
	providers: [AZC_AUTOCOMPLETE_SELECT_CONTROL_VALUE_ACCESSOR]
})
export class AutocompleteSelectComponent implements OnInit, ControlValueAccessor {
	@Output() private onFilter = new EventEmitter<string>();
	@Input() private multiple: boolean;
	@Input() public options: Observable<any[]>;
	@Input() public placeholder: string;
	@Input() public displayWith: (val: string) => string;
	@ViewChild('input') private input: ElementRef;
	private onChange: (value) => void;
	public onTouched: () => {} = () => null;
	public formControl: FormControl;
	public isDisabled: boolean;
	public values: any[];

	constructor(private _fb: FormBuilder) { }

	ngOnInit() {
		this.formControl = this._fb.control(null);
		this.formControl.valueChanges
			.pipe(map((input: string | null) => input))
			.subscribe(x => this.onFilter.emit(x));
	}

	remove(value: any): void {
		const index = this.values.indexOf(value);

		if (index >= 0) {
			this.values.splice(index, 1);
			this.onChange(this.multiple ? this.values : this.values[0]);

			if (!this.multiple) {
				this.formControl.enable();
			}
		}
	}

	selected(event: MatAutocompleteSelectedEvent): void {
		this.values.push(event.option.value);
		this.formControl.setValue(null);
		this.input.nativeElement.value = null;
		this.onChange(this.multiple ? this.values : this.values[0]);

		if (!this.multiple) {
			this.formControl.disable();
		}
	}

	writeValue(value: any[] | any): void {
		value = value || [];

		if (!Array.isArray(value)) {
			value = [value];
		}
		this.values = value;

		if (!this.multiple && this.values.length) {
			this.formControl.disable();
		}
	}

	registerOnChange(fn: (value: any) => void) {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	setDisabledState?(isDisabled: boolean): void {
		this.isDisabled = isDisabled;
	}
}
